import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Button } from '@mui/material';
import CompactAlertCard from './CompactAlertCard';
import AlertCard from './AlertCard';
import ThreeTablesModal from './SearchResultModal';
import MarketAlerts from './MarketAlerts';
import getUserId from '../functions/getUserId';

const InteractiveCompactAlertCard = ({
  alert,
  alertEffectiveness,
  onCheckboxChange,
  onFollowedUpChange,
  onReinvestmentCheck,
  onClose,
  ...props
}) => {
  // Mouseover effects removed per DAS-1286
  // const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isThreeTablesModalVisible, setIsThreeTablesModalVisible] = useState(false);
  const [selectedTicker, setSelectedTicker] = useState(null);
  const [isMarketAlertsVisible, setIsMarketAlertsVisible] = useState(false);
  const [selectedAlertSubtypeIdentifier, setSelectedAlertSubtypeIdentifier] = useState(null);

  const handleCardClick = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    onClose?.();
  };

  const handleTickerClick = (ticker) => {
    setSelectedTicker(ticker);
    setIsThreeTablesModalVisible(true);
  };

  const handleOpenMarketAlerts = (alertSubtypeIdentifier) => {
    setSelectedAlertSubtypeIdentifier(alertSubtypeIdentifier);
    setIsMarketAlertsVisible(true);
  };

  const handleCloseMarketAlerts = () => {
    setIsMarketAlertsVisible(false);
    setSelectedAlertSubtypeIdentifier(null);
  };

  return (
    <>
      <div
        style={{
          // Mouseover effects removed per DAS-1286
          transform: 'scale(1)',
          transition: 'none',
          cursor: 'pointer',
          zIndex: 1,
          position: 'relative',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          borderRadius: '8px',
          overflow: 'visible',
          margin: '6px',
          transformOrigin: 'center center',
          maxWidth: '100%'
        }}
        // Mouseover event handlers removed per DAS-1286
        onClick={handleCardClick}
      >
        <div
          style={{
            // Mouseover effects removed per DAS-1286
            transition: 'none',
            transform: 'scale(1)',
            opacity: 1,
            position: 'relative',
          }}
        >
          {/* Always show CompactAlertCard - no hover expansion per DAS-1286 */}
          <CompactAlertCard
            alert={alert}
            alertEffectiveness={alertEffectiveness}
            onClose={() => {}} // No close action needed for grid view
            onCheckboxChange={onCheckboxChange}
            onFollowedUpChange={onFollowedUpChange}
            onReinvestmentCheck={onReinvestmentCheck}
            onOpenMarketAlerts={handleOpenMarketAlerts}
            {...props}
          />
        </div>
      </div>

      {/* MUI Modal for clicked card */}
      <Dialog
        open={isModalOpen}
        onClose={handleModalClose}
        maxWidth={false}
        fullWidth={false}
        PaperProps={{
          style: {
            maxHeight: '90vh',
            overflow: 'auto',
            width: 'auto',
            maxWidth: '90vw',
            zIndex: 1300
          }
        }}
      >
        <DialogTitle>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Alert Details</span>
            <Button 
              type="text" 
              onClick={handleModalClose}
              style={{ minWidth: 'auto' }}
            >
              ✕
            </Button>
          </div>
        </DialogTitle>
        <DialogContent>
          <AlertCard
            alert={alert}
            alertEffectiveness={alertEffectiveness}
            onClose={handleModalClose}
            onCheckboxChange={onCheckboxChange}
            onFollowedUpChange={onFollowedUpChange}
            onReinvestmentCheck={onReinvestmentCheck}
            onTickerClick={handleTickerClick}
            onOpenMarketAlerts={handleOpenMarketAlerts}
            {...props}
          />
        </DialogContent>
      </Dialog>

      {/* ThreeTablesModal */}
      {isThreeTablesModalVisible && (
        <ThreeTablesModal
          tickerValue={selectedTicker}
          open={isThreeTablesModalVisible}
          onClose={() => setIsThreeTablesModalVisible(false)}
          userId={getUserId()}
        />
      )}

      {/* MarketAlerts Modal */}
      {isMarketAlertsVisible && (
        <MarketAlerts
          isVisible={isMarketAlertsVisible}
          onClose={handleCloseMarketAlerts}
          alertSubtypeIdentifier={selectedAlertSubtypeIdentifier}
        />
      )}
    </>
  );
};

export default InteractiveCompactAlertCard;
